import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import withStyles from '@mui/styles/withStyles';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';

// mui icons
import Assignment from '@mui/icons-material/Assignment';
import PlusIcon from '@mui/icons-material/Add';
import UpArrow from '@mui/icons-material/ArrowUpward';
import DownArrow from '@mui/icons-material/ArrowDownward';
// import EditIcon from "@mui/icons-material/Edit";
import Close from '@mui/icons-material/Close';
// import Save from "@mui/icons-material/Save";

// core components
import Table from '../md/components/Table/Table.jsx';
import Card from '../md/components/Card/Card.jsx';
import CardBody from '../md/components/Card/CardBody.jsx';
import CardIcon from '../md/components/Card/CardIcon.jsx';
import CardHeader from '../md/components/Card/CardHeader.jsx';

import { setFirmDropdowns } from '../store/slices/firmInfoSlice';
import { setApiResponseInfo } from '../store/slices/apiResponseInfoSlice';

import { createStdRequest, apiFetch, showAlert } from '../utils/utils';

import DA from '../store/ReduxAccess';
import ReduxLoader from '../store/ReduxLoader';

import CrmButton from '../components/CrmButton';
import KSelect from '../components/KSelect';
import ConfirmModal from '../components/ConfirmModal';
import PromptModal from '../components/PromptModal';
import AlertModal from '../components/AlertModal';

import blankImage from '../assets/img/transparent.png';

import { cardTitle, tooltip } from '../assets/jss/material-dashboard-pro-react.jsx';

const buttonWidth = 18;
const actionButtonPadding = 5;
const actionButtonLeftMargin = 5;
const spacerWidth = buttonWidth + actionButtonPadding * 2 + actionButtonLeftMargin;
const spacerHeight = 1;

const asPixels = (anInt) => String(anInt) + 'px';

const dropdownEditorStyle = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
  dropdownSelectDiv: {
    marginBottom: '16px',
  },
  tableHolderDiv: {
    maxHeight: '322px',
    paddingRight: '6px',
    overflow: 'auto',
  },
  tooltip,
  actionButton: {
    margin: '0 0 0 ' + asPixels(actionButtonLeftMargin),
    padding: asPixels(actionButtonPadding),
    '& svg,& .fab,& .fas,& .far,& .fal,& .material-icons': {
      marginRight: '0px',
    },
  },
  actionButtonSpacer: {
    width: asPixels(spacerWidth),
    height: asPixels(spacerHeight),
  },
  icon: {
    verticalAlign: 'middle',
    width: '17px',
    height: '17px',
    top: '-1px',
    position: 'relative',
  },
  right: {
    textAlign: 'right',
  },
  newItemButtonDiv: {
    textAlign: 'right',
  },
  newItemButton: {
    padding: '5px 10px',
    margin: 0,
    backgroundColor: '#007790',
  },
  saveOrCancelButtonDiv: {
    textAlign: 'right',
    marginTop: '16px',
  },
  saveItemButton: {
    padding: '5px 10px',
    margin: 0,
    backgroundColor: '#007790',
  },
  cancelItemButton: {
    padding: '5px 10px',
    margin: 0,
    backgroundColor: '#a33',
    marginLeft: '16px',
    '&:hover,&:focus': {
      backgroundColor: '#c55',
    },
  },
};

class DropdownEditor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      unauthorized: false,
      showItemEditorModal: false,
      showNewItemModal: false,
      loading: true,
      currentDropdownId: 0,
      dropdownName: '',
      items: [],
      idOfItemBeingEdited: 0,
    };
  }

  editedItemText = '';

  shouldManufactureState() {
    return DA.getFirmId() === 0;
  }

  quasiRedux = [];

  componentDidMount() {
    this.acquireState();
  }

  acquireState() {
    if (this.shouldManufactureState()) {
      this.manufactureState();
    } else {
      this.getStateFromRedux();
    }
  }

  getStateFromRedux() {
    this.quasiRedux = this.props.dropdowns;
    this.setState({ loading: false });
  }

  filterForEditabilityAndEditingAdvisability(reduxState) {
    const editableDropdowns = reduxState.filter((dd) => dd.editable);
    return editableDropdowns.filter((dd) => dd.name !== 'Activity Type');
  }

  manufactureState() {
    const dd1Items = [
      {
        dropdownItemId: 1,
        position: 0,
        text: 'DD 1; First Item',
        enabled: true,
      },
      {
        dropdownItemId: 2,
        position: 1,
        text: 'DD 1; Second Item',
        enabled: true,
      },

      {
        dropdownItemId: 3,
        position: 2,
        text: 'DD 1; Third Item',
        enabled: true,
      },
      {
        dropdownItemId: 4,
        position: 3,
        text: 'DD 1; Fourth Item',
        enabled: true,
      },
    ];
    const dd2Items = [
      {
        dropdownItemId: 21,
        position: 0,
        text: 'DD 2; First Item',
        enabled: true,
      },
      {
        dropdownItemId: 22,
        position: 1,
        text: 'DD 2; Second Item',
        enabled: true,
      },

      {
        dropdownItemId: 23,
        position: 2,
        text: 'DD 2; Third Item',
        enabled: true,
      },
      {
        dropdownItemId: 24,
        position: 3,
        text: 'DD 2; Fourth Item',
        enabled: true,
      },
    ];
    const dd1State = {
      name: 'Dropdown 1',
      dropdownId: 7,
      items: dd1Items,
    };
    const dd2State = {
      name: 'Dropdown 2',
      dropdownId: 14,
      items: dd2Items,
    };
    this.quasiRedux = [dd1State, dd2State];
    this.setState({ loading: false });
  }

  convertDropdownItemsToTableData(dropdownItems) {
    return dropdownItems.map((item) => [item.text, this.createActionButtonsForItem(item)]);
  }

  leftJustifyTableDataForItems(classes, actionButtonRows) {
    const rowLengths = actionButtonRows.map((row) => row[1].length);
    const maxPerRow = rowLengths.reduce((a, b) => Math.max(a, b), 0);
    return actionButtonRows.map((row) => this.extendRowToSize(classes, row, maxPerRow));
  }

  extendRowToSize(classes, row, intendedSize) {
    let rowTemp = row;
    const rowName = row[0];
    let keySuffix = 0;
    while (rowTemp[1].length < intendedSize) {
      const key = rowName + keySuffix;
      rowTemp = [
        rowName,
        [...rowTemp[1], <img key={key} className={classes.actionButtonSpacer} src={blankImage} alt="" />],
      ];
      keySuffix += 1;
    }
    return rowTemp;
  }

  handleDropdownNameChange(event) {
    const newName = event.target.value;
    const oldName = this.state.dropdownName;
    if (oldName) {
      this.saveCurrentStateToQuasiRedux();
    }
    this.setStateForDropdownName(newName);
  }

  setStateForDropdownName(dropdownName) {
    const ddStruct = this.quasiRedux.find((stct) => stct.name === dropdownName);
    const items = ddStruct.items;
    this.setState({ dropdownName, items });
  }

  saveCurrentStateToQuasiRedux() {
    const currentDdName = this.state.dropdownName;
    if (!currentDdName) {
      return;
    }
    const dropdownToModify = this.quasiRedux.find((dd) => dd.name === currentDdName);
    const otherDds = this.quasiRedux.filter((dd) => dd.name !== currentDdName);
    const modifiedDd = { ...dropdownToModify, items: this.state.items };
    const newList = [...otherDds, modifiedDd];
    const sorted = newList.sort((dd1, dd2) => dd1.dropdownId - dd2.dropdownId);
    this.quasiRedux = sorted;
  }

  addNewItem() {
    this.setState({ showNewItemModal: true });
  }

  moveUpInList(itemId) {
    const clickedItem = this.getItemWithId(itemId);
    const oldPosition = clickedItem.position;
    if (oldPosition === 0) {
      return;
    }
    const newPosition = oldPosition - 1;
    const otherMovingItem = this.getItemAtPosition(newPosition);
    const otherItems = this.state.items.filter(
      (itm) => itm.dropdownItemId !== itemId && itm.dropdownItemId !== otherMovingItem.dropdownItemId
    );
    const newOtherItem = { ...otherMovingItem, position: oldPosition };
    const newClickedItem = { ...clickedItem, position: newPosition };
    const newItemsList = otherItems.concat([newOtherItem, newClickedItem]);
    this.setState({ items: newItemsList });
  }

  getItemWithId(itemId) {
    return this.state.items.find((item) => item.dropdownItemId === itemId);
  }

  getItemAtPosition(position) {
    return this.state.items.find((item) => item.position === position);
  }

  moveDownInList(itemId) {
    const clickedItem = this.getItemWithId(itemId);
    const oldPosition = clickedItem.position;
    if (oldPosition >= this.state.items.length - 1) {
      return;
    }
    const newPosition = oldPosition + 1;
    const otherMovingItem = this.getItemAtPosition(newPosition);
    const otherItems = this.state.items.filter(
      (itm) => itm.dropdownItemId !== itemId && itm.dropdownItemId !== otherMovingItem.dropdownItemId
    );
    const newOtherItem = { ...otherMovingItem, position: oldPosition };
    const newClickedItem = { ...clickedItem, position: newPosition };
    const newItemsList = otherItems.concat([newOtherItem, newClickedItem]);
    this.setState({ items: newItemsList });
  }

  editItem(itemId) {
    const clickedItem = this.getItemWithId(itemId);
    this.editedItemText = clickedItem.text;
    this.setState({ showItemEditorModal: true, idOfItemBeingEdited: itemId });
  }

  hideItem(itemId) {
    if (this.state.items.length === 1) {
      let message = "Sorry, but you're not allowed to delete all the items in a list.";
      message += "\nMaybe you'd like to add another item and then delete this one.";
      showAlert(this, message);
      return;
    }
    const clickedItem = this.getItemWithId(itemId);
    const q = `Are you sure you want to delete the item '${clickedItem.text}'?`;
    this.setState({
      shouldShowDeletionConfirmationModal: true,
      deletionConfirmationQuery: q,
      deleteFunc: () => this.hideItemAfterConfirmation(itemId, clickedItem),
    });
  }

  hideItemAfterConfirmation(itemId, clickedItem) {
    const otherItems = this.state.items.filter((itm) => itm.dropdownItemId !== itemId);
    const newClickedItem = { ...clickedItem, enabled: false };
    const newItemsList = [...otherItems, newClickedItem];
    const renumberedList = this.renumberJustEnabled(newItemsList);
    this.setState({ items: renumberedList });
  }

  renumberJustEnabled(itemsList) {
    const sorted = this.filterAndSortItems(itemsList);
    let i = -1;
    const renumbered = sorted.map((item) => {
      i++;
      return { ...item, position: i };
    });
    return renumbered;
  }

  saveChanges() {
    this.saveCurrentStateToQuasiRedux();

    const firmId = DA.getFirmId();
    const uri = `/api/firm/${firmId}/customizableDropdowns`;
    const apiStruct = { dropdowns: this.quasiRedux };
    const request = createStdRequest(uri, 'POST', apiStruct);
    const actionOnGoodResponse = (json) => {
      const dropdowns = json.dropdowns;
      this.props.setFirmDropdowns(dropdowns);
      this.getStateFromRedux();
      ReduxLoader.initProspectLeadTemperatureInclusionFilterState();
      this.setState({ dropdownName: '' });
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  cancelChanges() {
    this.setStateForDropdownName(this.state.dropdownName);
  }

  filterAndSortItems(items) {
    const filteredItems = items.filter((item) => item.enabled);
    const sortedItems = filteredItems.sort((i1, i2) => i1.position - i2.position);
    return sortedItems;
  }

  handleConfirmNewItemModal(newText) {
    if (newText.length < 1) {
      showAlert(this, 'You need to supply text for the Item');
      return;
    }
    const originalItems = this.state.items;
    const newId = 0 - this.hash(newText);
    const newItem = {
      dropdownItemId: newId,
      text: newText,
      position: originalItems.length,
      enabled: true,
      isProtected: false,
    };
    const newItems = originalItems.concat(newItem);
    this.setState({ items: newItems }, () => this.scrollToBottom());
    this.closeNewItemModal();
  }

  hash(str) {
    let hash = 0;
    if (str.length === 0) {
      return hash;
    }
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
  }

  closeNewItemModal() {
    this.setState({ showNewItemModal: false });
  }

  scrollToBottom() {
    const tableHoldingDiv = document.getElementById('tableHoldingDiv');
    tableHoldingDiv.scrollTop = tableHoldingDiv.scrollHeight;
  }

  handleConfirmItemEditorModal(newText) {
    this.editedItemText = newText;
    const itemId = this.state.idOfItemBeingEdited;
    const clickedItem = this.getItemWithId(itemId);
    const modifiedItem = { ...clickedItem, text: newText };
    const otherItems = this.state.items.filter((item) => item.dropdownItemId !== itemId);
    const allItems = otherItems.concat(modifiedItem);
    this.setState({ items: allItems });
    this.closeItemEditorModal();
  }

  closeItemEditorModal() {
    this.setState({ showItemEditorModal: false });
  }

  createActionButtonsForItem(item) {
    const { classes } = this.props;
    const itemId = item.dropdownItemId;

    const moveUpButton = (
      <IconButton
        key="moveUp"
        className={classes.actionButton}
        color="secondary"
        onClick={() => this.moveUpInList(itemId)}
        size="large"
      >
        <UpArrow className={classes.icon} />
      </IconButton>
    );

    const moveDownButton = (
      <IconButton
        key="moveDown"
        className={classes.actionButton}
        color="secondary"
        onClick={() => this.moveDownInList(itemId)}
        size="large"
      >
        <DownArrow className={classes.icon} />
      </IconButton>
    );

    /*
    const editButton = (
      <Button
            key="edit"
            className={classes.actionButton}
            color="info"
            onClick={() => this.editItem(itemId)}
            >
          <EditIcon className={classes.icon} />
      </Button>);
    */

    const hideButton = (
      <IconButton
        key="hide"
        className={classes.actionButton}
        color="primary"
        onClick={() => this.hideItem(itemId)}
        size="large"
      >
        <Close className={classes.icon} />
      </IconButton>
    );

    return item.isProtected
      ? [moveUpButton, moveDownButton /* , editButton*/]
      : [moveUpButton, moveDownButton /* , editButton*/, hideButton];
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} push />;
    }

    if (this.state.unauthorized) {
      return (
        <div>
          <h2>Sorry! You're not allowed to be here.</h2>;
          <h3>You need to be logged in as an AllevaRep or SuperAdmin.</h3>;
        </div>
      );
    }

    if (this.state.loading) {
      return <h2>Loading...</h2>;
    }

    const { classes } = this.props;
    const filteredState = this.filterForEditabilityAndEditingAdvisability(this.quasiRedux);
    const dropdownNames = filteredState.map((stct) => stct.name).sort();
    const dropdownItems = this.filterAndSortItems(this.state.items);

    return (
      <div>
        <AlertModal show={this.state.shouldShowAlertModal} renderer={this} text={this.state.alertModalText} />

        <ConfirmModal
          show={this.state.shouldShowDeletionConfirmationModal}
          title="Confirm Deletion"
          confirmButtonLabel="Delete"
          rejectButtonLabel="Cancel"
          onConfirm={this.state.deleteFunc}
          onReject={() => this.setState({ shouldShowDeletionConfirmationModal: false })}
        >
          <div>{this.state.deletionConfirmationQuery}</div>
        </ConfirmModal>

        <PromptModal
          show={this.state.showNewItemModal}
          title="Define a New Dropdown Item"
          inputLabel="New Menu Item"
          initialValue=""
          onConfirm={(newItemText) => this.handleConfirmNewItemModal(newItemText)}
          onCancel={() => this.closeNewItemModal()}
        />
        <PromptModal
          show={this.state.showItemEditorModal}
          title="Modify the Dropdown Item Text"
          inputLabel="New Text"
          initialValue={this.editedItemText}
          onConfirm={(newValue) => this.handleConfirmItemEditorModal(newValue)}
          onCancel={() => this.closeItemEditorModal()}
        />
        <Grid container>
          <Grid item md={3} />
          <Grid item md={6}>
            <Card>
              <CardHeader icon>
                <CardIcon color="allevaOrange">
                  <Assignment />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Customize Dropdowns</h4>
              </CardHeader>
              <CardBody>
                <div className={classes.dropdownSelectDiv}>
                  <KSelect
                    id="dropdownSelect"
                    name="dropdown"
                    fullWidth={true}
                    label="Choose a Dropdown to Customize"
                    displayEmpty={true}
                    disabledOption="Choose..."
                    liveOptions={dropdownNames}
                    value={this.state.dropdownName}
                    onChange={(event) => this.handleDropdownNameChange(event)}
                  />
                </div>
                {this.state.dropdownName && (
                  <div className={classes.newItemButtonDiv}>
                    <Button
                      color="primary"
                      variant="contained"
                      startIcon={<PlusIcon style={{ color: 'white' }} />}
                      onClick={() => this.addNewItem()}
                    >
                      <span style={{ color: 'white', fontWeight: 600 }}>Add New Item</span>
                    </Button>
                  </div>
                )}
                {this.state.dropdownName && (
                  <div id="tableHoldingDiv" className={classes.tableHolderDiv}>
                    <Table
                      tableHead={['Item Text', 'Actions']}
                      tableData={this.leftJustifyTableDataForItems(
                        classes,
                        this.convertDropdownItemsToTableData(dropdownItems)
                      )}
                      customCellClasses={[classes.right, classes.right]}
                      customClassesForCells={[1, 2]}
                      customHeadCellClasses={[classes.right, classes.right]}
                      customHeadClassesForCells={[1, 2]}
                    />
                  </div>
                )}
                {this.state.dropdownName && (
                  <div className={classes.saveOrCancelButtonDiv}>
                    <CrmButton outlined onClick={() => this.cancelChanges()}>
                      Cancel
                    </CrmButton>
                    <CrmButton filled onClick={() => this.saveChanges()}>
                      Save
                    </CrmButton>
                  </div>
                )}
              </CardBody>
            </Card>
          </Grid>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  dropdowns: state.firmInfo.dropdowns,
});

const actionProducers = {
  setFirmDropdowns,
  setApiResponseInfo,
};

export default connect(mapStateToProps, actionProducers)(withStyles(dropdownEditorStyle)(DropdownEditor));
